import { Box, Button, Typography } from '@mui/material'
import { FormFilter } from 'shared/components/form-filter/FormFilter'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Layout } from 'shared/utils'
import { useContracts } from './hook/useContracts'
import { TableComponent } from 'shared/components/Table.component'
import { useWidth } from 'shared/hooks/HookDetailedConsultation/useWidth'
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Spinner } from 'shared';
import styles from './styles/contract.module.scss'

export const Contracts = () => {

  const { 
    dataFields, 
    getValueDatePickerEnd,
    getValueDatePickerStart,
    maxDate,
    onChangesDatePicker,
    handleChange,
    handleSubmit,
    values,
    columns,
    valuesResultsPages,
    showForm,
    loading,
    toogleShowForm,
    uploadDocument,
  } = useContracts();
  const { width } = useWidth();
  
  
  return (
    <Layout>
        <Box display={'flex'} justifyContent={'space-between'} marginTop={'.3rem'}>
          <Typography className='fs-6 fs-bold' variant='body2'>Contratos</Typography>
          <Box display={'flex'} gap={1}>
            <Button 
              className={styles.buttonsActions}
              onClick={uploadDocument}
              endIcon={<UploadFileIcon/>}
              variant='contained' 
              data-testid='update-excel'
            >
              Cargar
            </Button>
            <Button 
              className={styles.buttonsActions}
              onClick={toogleShowForm}
              endIcon={<FilterAltIcon/>}
              variant='contained' 
              data-testid='btn-filters-contracts'
            >
              Filtrar
            </Button>

          </Box>
        </Box>
        {
          showForm && (
            <FormFilter 
              dataFields={dataFields} 
              getValueDatePickerEnd={getValueDatePickerEnd}
              getValueDatePickerStart={getValueDatePickerStart}
              onChangesDatePicker={onChangesDatePicker}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              handleUserAssignment={()=>{}}
              maxDate={maxDate}
              values={values}
            />
          )
        }
        <Box paddingTop={'.5rem'} height={showForm ? '72%' : '90%'}>
          <TableComponent 
            columns={columns}
            title=''
            valuesResultsPages={valuesResultsPages}
            classTotalElemnt={width < 500 ? '' : 'classTotalElemnt'}
            showBtnCollapse={false}
            hiddenHeaderSearch={true}
          />
        </Box>
        {( loading ) && <Spinner />}
    </Layout>
  )
}
